import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/rat/alterar/:id',
    name: 'altlerar-rat',  
    component: () => import('../views/RATView.vue'),
    //meta: { requiresAuth: true } // precisa estar logado
  },
  {
    path: '/rat/assinatura/:id/:tipo',
    name: 'altlerar-assinatura',  
    component: () => import('../views/AssinaturaView.vue'),
    //meta: { requiresAuth: true } // precisa estar logado
  }     
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
